interface RepairProcessImage {
  label: string;
  checkInImage: string[];
  info: {
    processName: string;
    detailList: {
      name: string;
      path: string[];
    }[];
  }[][];
}
export const RepairProcessImage = ({
  info,
  label,
  checkInImage,
}: RepairProcessImage) => {
  return (
    <div className={'repair-process-image-field'}>
      <div className={'repair-process-image-label'}>
        <span>{label}</span>
      </div>
      <div className={'repair-process-image-item'}>
        <div className={'process-name-label'}>
          <span>{'入庫時'}</span>
        </div>
        <div className={'process-image-item'}>
          <div className={'image-item'}>
            {checkInImage.map((path, idx) => (
              <img key={idx} src={path} />
            ))}
          </div>
        </div>
      </div>
      {info.map((infoItem) =>
        Object.values(infoItem).map((item, idx) => (
          <div className="process-image-field" key={idx}>
            <div className={'process-name-label'}>
              <span>{item.processName}</span>
            </div>
            {item.detailList.map((detail, idx) => (
              <div className={'process-image-item'} key={idx}>
                {detail.path.map((path, pathIdx) => (
                  <div className={'image-item'} key={pathIdx}>
                    <img src={path} />
                  </div>
                ))}
                <div className={'image-label'}>
                  <span>{detail.name}</span>
                </div>
              </div>
            ))}
          </div>
        )),
      )}
    </div>
  );
};
